/* eslint-disable */
import PropTypes from 'prop-types';
import React from 'react';

import { registerBenefitsClick } from 'ggApp/modules/gaAnalytics/actions';

import { Container, Icon, Title } from './styles';

const Item = ({
    className, icon, title, openOverlay,
}) => {
    const handleClick = () => {
        openOverlay();
        registerBenefitsClick(title, 'enter');
    };
    return (
        <Container className={className} onClick={handleClick}>
            <Icon>{icon}</Icon>
            <Title color="#17CCA8">{title}</Title>
        </Container>
    );
};

Item.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
    openOverlay: PropTypes.func,
};

Item.defaultProps = {
    title: '',
    className: '',
    openOverlay: () => {},
};

export default Item;
